import { useMemo } from 'react'
import { formatInTimeZone } from 'date-fns-tz'
import { useSearchParams } from 'react-router-dom'
import { useAppQuery } from '@/helpers/api/query'

import { createInstance } from '@/helpers/api/base'
import { Disruption } from '@/types/disruptions'
import { useDateStore } from '@/components/DateInput'

const GET_SHARED_DISRUPTIONS_KEY = 'GET_SHARED_DISRUPTIONS'

export const useGetSharedDisruptions = () => {
    const { date } = useDateStore()
    const [searchParams] = useSearchParams()
    const sharedDisruptionId = searchParams.get('id')
    const route = searchParams.get('route')

    const params = useMemo(() => {
        const formattedDate = formatInTimeZone(date, 'UTC', "yyyy-MM-dd'T'HH:mm:ss")

        return [route, formattedDate].filter((value) => value)
    }, [sharedDisruptionId, route, date])

    return useAppQuery<Disruption[]>({
        queryKey: [GET_SHARED_DISRUPTIONS_KEY, ...params],
        queryFn: ({ queryKey, signal }) =>
            createInstance({
                url: '/disruptions',
                method: 'GET',
                params: {
                    Routes: queryKey[1] as string,
                },
                signal,
            }),
        enabled: params.length > 1,
    })
}
